import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf2bf084"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 关联附件 ", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("关联")
const _hoisted_3 = { class: "d-flex d-flex-row-reverse" }

import {getCurrentInstance, reactive, watch} from "vue";
import tbMix from "@/global_mixin/tableMixin";
import Api from "@/http/modules";


export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit }) {

const props = __props as {
  show: boolean
}

const {
  "POST/office/asset/invoice_expense_voucher_list": officeAssetIevListApi,
} = Api


const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(officeAssetIevListApi)
const ievDialogInfo = reactive({
  isShow: false
})
let instance: any = getCurrentInstance()


const onClick = (row: any) => {
  emit("select", row)
  ievDialogInfo.isShow = false
}
watch(() => props.show, (curr, old) => {
  if (curr) {
    fetchData()
    ievDialogInfo.isShow = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    class: "ievDialog",
    modelValue: _unref(ievDialogInfo).isShow,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(ievDialogInfo).isShow) = $event)),
    draggable: "",
    width: "1200px"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "ievTbEle",
          border: "",
          class: "mt-10",
          data: _unref(MI_tableData),
          "row-key": "id",
          "max-height": _unref(MI_height) - 100 + 'px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "ID",
              prop: "id",
              width: "50",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "开票结算组织",
              prop: "payeeCompany",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              label: "报销项目",
              prop: "reimbursementItemName",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "费用类别",
              prop: "expenseCategoryName",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "报销金额",
              prop: "totalAmount",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "发票金额",
              prop: "invoiceAmount",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "款项用途",
              prop: "moduleDesc",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              prop: "voucherStatusDesc",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "单据收集状态",
              prop: "approveStatus",
              width: "160"
            }),
            _createVNode(_component_el_table_column, {
              label: "支付状态",
              prop: "payStatus",
              width: "100"
            }),
            _createVNode(_component_el_table_column, {
              label: "创建时间",
              prop: "createdAt",
              width: "118"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (onClick(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "max-height"])), [
          [_directive_loading, _unref(MI_identify)]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_pagination, {
            disabled: _unref(MI_identify),
            background: "",
            small: "",
            total: _unref(MI_total),
            currentPage: _unref(page),
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
            "page-size": _unref(size),
            "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
            class: "mt-10",
            "page-sizes": [10, 30, 50, 100, 300, 1000],
            layout: "sizes, prev, pager, next, total, jumper",
            onCurrentChange: _unref(MI_pageChange),
            onSizeChange: _unref(MI_sizeChange)
          }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})